module.exports = __webpack_public_path__ + "static/media/sustainable_coastlines_logo.19b6b110.svg";